/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import AccountConnectionData from 'ads-account-connection/data/AccountConnectionData';
import { openFBAuthWindow } from 'ads-account-connection/lib/Utils';
import { getFullUrl } from 'hubspot-url-utils';
const USER_DOES_NOT_HAVE_ACCESS_TO_AD_ACCOUNT = 'USER_DOES_NOT_HAVE_ACCESS_TO_AD_ACCOUNT';

const createLoginURL = data => {
  const redirectUri = `${getFullUrl('app')}/ads-authentication/facebook-business-extension/auth-callback`;
  const extras = JSON.stringify(data.extras);
  return `${data.loginUrl}?` + `client_id=${encodeURIComponent(data.client_id)}&` + `display=${encodeURIComponent(data.display)}&` + `redirect_uri=${encodeURIComponent(redirectUri)}&` + `response_type=${encodeURIComponent(data.response_type)}&` + `scope=${encodeURIComponent(data.scope)}&` + `extras=${encodeURIComponent(extras)}`;
};

const ConfirmLoadingButton = props => {
  const {
    onClick
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["onClick"]);

  return /*#__PURE__*/_jsxs(UIButton, Object.assign({}, rest, {
    onClick: onClick,
    external: true,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.conversionsApi.confirmModal.continueButton"
    }), /*#__PURE__*/_jsx(UIIcon, {
      name: "externalLink"
    })]
  }));
};

const FacebookDataSyncModal = ({
  adAccountId,
  pixelId,
  onClose,
  onExternalBusinessIdChange,
  setError,
  isEventCreation
}) => {
  const handleConfirm = () => {
    AccountConnectionData.fetchFBELogin(adAccountId, pixelId).then(response => {
      const fbLoginUrl = createLoginURL(response);
      openFBAuthWindow(fbLoginUrl);
      onExternalBusinessIdChange(response.extras.setup.external_business_id);
    }).catch(err => {
      if (err && err.responseJSON && err.responseJSON.errorType === USER_DOES_NOT_HAVE_ACCESS_TO_AD_ACCOUNT) {
        setError(USER_DOES_NOT_HAVE_ACCESS_TO_AD_ACCOUNT);
      }
    }).finally(() => {
      onClose();
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };

  return /*#__PURE__*/_jsx(UIConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `ADS_ACCOUNT_CONNECTION.conversionsApi.confirmModal.header.${isEventCreation ? 'eventCreation' : 'default'}`
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `ADS_ACCOUNT_CONNECTION.conversionsApi.confirmModal.description.${isEventCreation ? 'eventCreation' : 'default'}`
    }),
    ConfirmButton: ConfirmLoadingButton,
    onConfirm: handleConfirm,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.conversionsApi.confirmModal.cancelButton"
    }),
    onReject: onClose
  });
};

FacebookDataSyncModal.propTypes = {
  adAccountId: PropTypes.string.isRequired,
  pixelId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onExternalBusinessIdChange: PropTypes.func.isRequired
};
export default FacebookDataSyncModal;